import { render, staticRenderFns } from "./ChatPriority.vue?vue&type=template&id=b2bf71c8"
import script from "./ChatPriority.vue?vue&type=script&lang=js"
export * from "./ChatPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports